export class Greentaxftl {
    public REC_ID!: number;
    public FROM_LOC!: number;
    public TO_LOC!: number;
    public VEH_TYPE!: string;
    public GREEN_TAX!: number;
    public CREATEDBY_USERID!: number;
    public UPDATEDBY_USERID!: number;
    public CREATED_DATE!: string; //Date;
    //Date;
    public UPDATED_DATE!: string; //Date;
    //Date;
    public IS_ACTIVE!: boolean;
}